import { axiosGet, axiosPost } from "../../react_axios/Axios"
import {
    getEnquiryListUrl, GET_ENQUIRY_LIST_ACTION, getEnquiryDetailsUrl, GET_ENQUIRY_DETAILS,
    headers,
    getEventEnquiryListUrl,
    GET_EVENT_ENQUIRY_LIST_ACTION_TYPE,
    getEventEnquiryDetailsUrl,
    GET_EVENT_ENQUIRY_DETAILS_ACTION_TYPE,
    INSERT_UPDATE_EVENT_ENQUIRY_ACTION_TYPE,
    insertUpdateEventEnquiryUrl,
    deleteEventEnquiryUrl,
    DELETE_EVENT_ENQUIRY_ACTION_TYPE
} from "../../utils/constants"

export const get_eventEnquiry_List_action = (CompanyName, Email) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('UserIDSS') ? sessionStorage.getItem('UserIDSS') : null,
            CompanyName: CompanyName,
            Email: Email
        }

        const res = await axiosGet(getEventEnquiryListUrl, mapdata, headers);
        console.log("registrationOneAdd_action res", res)

        dispatch({
            type: GET_EVENT_ENQUIRY_LIST_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const get_eventEnquiry_Details_action = (EventEnquiryID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('UserIDSS') ? sessionStorage.getItem('UserIDSS') : null,
            EventEnquiryID: EventEnquiryID
        }

        const res = await axiosGet(getEventEnquiryDetailsUrl, mapdata, headers);
        console.log("registrationOneAdd_action res", res)

        dispatch({
            type: GET_EVENT_ENQUIRY_DETAILS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insert_update_eventEnquiry_action = (EventEnquiryID, EventID, CompanyName, PersonName, Designation, CountryID, City, State, MobileNo, Email, Remark) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            EventEnquiryID: EventEnquiryID,
            EventID: EventID,
            CompanyName: CompanyName,
            PersonName: PersonName,
            Designation: Designation,
            CountryID: CountryID,
            City: City,
            State: State,
            MobileNo: MobileNo,
            Email: Email,
            Remark: Remark,
        }

        console.log("share_credential_action res", mapdata)
        const res = await axiosPost(insertUpdateEventEnquiryUrl, mapdata, headers);

        dispatch({
            type: INSERT_UPDATE_EVENT_ENQUIRY_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
}

export const delete_eventEnquiry_action = (EventEnquiryID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            EventEnquiryID: EventEnquiryID
        }
        const res = await axiosGet(deleteEventEnquiryUrl, mapdata, headers);
        dispatch({
            type: DELETE_EVENT_ENQUIRY_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};